import { render, staticRenderFns } from "./FormResponseDetail.vue?vue&type=template&id=13a0f2c8&scoped=true"
import script from "./FormResponseDetail.vue?vue&type=script&lang=js"
export * from "./FormResponseDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a0f2c8",
  null
  
)

export default component.exports